import { memo } from 'react';

import Typography from 'components/UI/Typography/Typography';
import Section from 'components/pages/Analytics/Layout/Section/Section';

import styles from './Banner.module.scss';

const Banner = () => (
  <Section className={styles.section}>
    <div className={styles.banner}>
      <Typography type="heading-md" weight="semibold" color="white">
        Evoplay Games Analytics
      </Typography>
      <Typography color="white">
        Driving your growth through performance and trends
      </Typography>
    </div>
  </Section>
);

export default memo(Banner);
